import PromoBannerTooltip from "@/components/PromoBanner/components/PromoBannerTooltip";
import type { BasePromoBannerProps } from "@/components/PromoBanner/types";

export default function PromoBannerCompactPDP({
  ctaElement,
  compact,
}: BasePromoBannerProps) {
  if (!compact) {
    return null;
  }
  return (
    <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-2 md:gap-4 p-4 md:p-8 bg-primary rounded-xl">
      <div>
        <h2 className="text-primary-foreground mt-0 mb-0 md:mb-2 text-3xl text-center md:text-left">
          <span className="md:hidden text-2xl">
            {compact.headlineMobile || compact.headline}
          </span>
          <span className="hidden md:inline">{compact.headline}</span>
        </h2>
        <p className="text-primary-foreground elm-p3 mb-0 text-md text-center md:text-left">
          <span className="md:hidden text-sm">
            {compact.subtextMobile || compact.subtext}
          </span>
          <span className="hidden md:inline">{compact.subtext}</span>{" "}
          {compact.infoText && (
            <span className="inline-block align-middle">
              <PromoBannerTooltip htmlContent={compact.infoText} size={16} />
            </span>
          )}
        </p>
      </div>
      <div className="w-full md:w-auto flex justify-center md:justify-end items-center whitespace-nowrap">
        {ctaElement}
      </div>
    </div>
  );
}
